import { fetchConfig } from '@theme/utilities';
import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

if (!customElements.get('cart-variant-updater')) {
  class CartVariantUpdater extends HTMLElement {
    constructor() {
      super();
      this.currentVariantId = this.dataset.variantId;
      this.selectedVariantId = this.currentVariantId;
      this.lineIndex = this.dataset.lineIndex;
    }

    connectedCallback() {
      this.select = this.querySelector('.cart-variant-select');
      this.select?.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      this.selectedVariantId = event.target.value;

      if (this.selectedVariantId === this.currentVariantId) return;

      // Get the current quantity from the quantity input in the same row
      const row = this.closest('tr');
      const quantityInput = row?.querySelector('quantity-selector-component input[type="number"], cart-quantity-selector-component input[type="number"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      this.switchVariant(quantity);
    }

    async switchVariant(quantity) {
      const sectionId = this.closest('cart-items-component')?.dataset.sectionId;
      if (!sectionId) return;

      const updates = {
        [this.currentVariantId]: 0,
        [this.selectedVariantId]: quantity,
      };

      try {
        this.classList.add('cart-variant-updater--loading');

        // Shimmer the line item price and the cart total
        const row = this.closest('tr');
        const textComponent = row?.querySelector('text-component');
        textComponent?.shimmer?.();
        const cartTotal = this.closest('cart-items-component')?.querySelector('[ref="cartTotal"]');
        cartTotal?.shimmer?.();

        const body = JSON.stringify({
          updates,
          sections: sectionId,
          sections_url: window.location.pathname,
        });

        const res = await fetch(
          `${Theme.routes.cart_update_url}.js`,
          fetchConfig('json', { body })
        );

        const data = await res.json();

        if (data.errors) {
          console.error('Variant switch error:', data.errors);
          // Revert the select back to the original variant
          if (this.select) this.select.value = this.currentVariantId;
          return;
        }

        // Update internal state
        this.currentVariantId = this.selectedVariantId;
        this.dataset.variantId = this.selectedVariantId;

        // Get new item count from updated section HTML
        const newSectionHTML = new DOMParser().parseFromString(
          data.sections[sectionId],
          'text/html'
        );
        const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
        const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

        // Dispatch cart update event so the cart bubble and other components update
        document.dispatchEvent(
          new CartUpdateEvent(data, sectionId, {
            itemCount: newCartItemCount,
            source: 'cart-variant-updater',
            sections: data.sections,
          })
        );

        // Morph the section to reflect the new state
        morphSection(sectionId, data.sections[sectionId]);
      } catch (err) {
        console.error('Variant switch failed:', err);
        // Revert select on error
        if (this.select) this.select.value = this.currentVariantId;
      } finally {
        this.classList.remove('cart-variant-updater--loading');
      }
    }
  }

  customElements.define('cart-variant-updater', CartVariantUpdater);
}
